import { DateTimeRange } from '../types';
import { getDateTimeRangeString } from './getDateTimeRangeString';

export const isMatchingPreset = (
  preset: DateTimeRange,
  value: DateTimeRange,
) => {
  if (getDateTimeRangeString(preset) !== getDateTimeRangeString(value)) {
    return false;
  }
  if (preset.type === 'last' && value.type === 'last') {
    return preset.unit === value.unit;
  }
  return preset.type === value.type;
};
